module.exports = __webpack_public_path__ + "img/admin-level-1.31485b50.png";